import { AuthConsumerRenderProps, withAuthContext } from 'auth/AuthContext';
import CompaniesView from 'components/guarantors/company/CompaniesView';
import ContractDocumentView from 'components/guarantors/contract-document/ContractDocumentView';
import DivisionsView from 'components/guarantors/division/DivisionsView';
import EmployeesImportView from 'components/guarantors/employee/EmployeesImportView';
import EmployeesView from 'components/guarantors/employee/EmployeesView';
import GuarantorsView from 'components/guarantors/GuarantorsView';
import SectionContainer from 'components/section/SectionContainer';
import { SectionPage } from 'components/section/SectionPage';
import React from 'react';
import { Privilege } from 'ts-types/api.enums';
import GuarantorUpdateView from 'components/guarantors/GuarantorUpdateView';
import PatientEmailImportView from 'components/guarantors/patient-emails/PatientEmailImportView';
import BroadcastEmailRunView from 'components/guarantors/patient-emails/BroadcastEmailRunView';

interface Props extends AuthConsumerRenderProps {

}

const GuarantorsHome = (props: Props) => {
  const pages: SectionPage[] = [
    {id: "guarantors", uri: "/guarantors", component: GuarantorsView}
  ];

  const isGuarantorPrivileged = props.currentUserHasPrivilege(Privilege.PX_CORE_GUARANTORS_CONFIGURATION);
  if (isGuarantorPrivileged) {
    pages.push({id: "companies", uri: "/guarantors/companies", component: CompaniesView});
    pages.push({id: "employees", uri: "/guarantors/employees", component: EmployeesView});
    pages.push({id: "employeesImport", uri: "/guarantors/employees-import", component: EmployeesImportView});
    pages.push({id: "divisions", uri: "/guarantors/division", component: DivisionsView});
    pages.push({id: "contract", uri: "/guarantors/contract", component: ContractDocumentView});
    pages.push({id: "guarantorUpdate", uri:"/guarantors/guarantor-update", component: GuarantorUpdateView});
    pages.push({id: "patientEmailImport", uri:"/guarantors/patient-email-import",
      component: PatientEmailImportView});
    pages.push({id: "broadcastEmailRun", uri:"/guarantors/broadcast-email-run",
      component: BroadcastEmailRunView});
  }

  return (
      <SectionContainer sectionPages={pages}/>
  );
};

export default withAuthContext(GuarantorsHome);
